import type { Translate } from '@application/types';

export const readableDate = (duration: plugin.Duration, translate: Translate) => {
  const years = Math.abs(duration.years());
  const months = Math.abs(duration.months());
  const days = Math.abs(duration.days());
  const hours = Math.abs(duration.hours());
  const minutes = Math.abs(duration.minutes());

  if (years > 0) {
    return translate('common.readableDate.multiple')
      .replace('$unit1', translate('common.readableDate.years'))
      .replace('$number1', years.toString())
      .replace('$unit2', translate('common.readableDate.months'))
      .replace('$number2', months.toString());
  }
  if (months > 0) {
    return translate('common.readableDate.multiple')
      .replace('$unit1', translate('common.readableDate.months'))
      .replace('$number1', months.toString())
      .replace('$unit2', translate('common.readableDate.days'))
      .replace('$number2', days.toString());
  }
  if (days > 0) {
    return translate('common.readableDate.single')
      .replace('$unit', translate('common.readableDate.days'))
      .replace('$number', days.toString());
  }
  if (hours) {
    return translate('common.readableDate.single')
      .replace('$unit', translate('common.readableDate.hours'))
      .replace('$number', hours.toString());
  }
  if (minutes > 0) {
    return translate('common.readableDate.single')
      .replace('$unit', translate('common.readableDate.minutes'))
      .replace('$number', minutes.toString());
  }
  return translate('common.readableDate.online');
};
